export default __webpack_public_path__ + "static/media/mri.14be37e1.png";